import request from '../../utils/request'

const preFix = '/system/order';

export const reqListOrder = (data) => {
    return request({
        url: preFix + '/page',
        method: 'POST',
        data: data
    })
}
export const reqExportOrder = (data) => {
    return request({
        url: preFix + '/export',
        method: 'POST',
        data: data,
        responseType: 'blob'
    })
}
export const reqListDeptOrder = (data) => {
    return request({
        url: preFix + '/deptOrder',
        method: 'get',
        params: data
    })
}
export const exportDeptOrder = (data) => {
    return request({
        url: preFix + '/exportDeptOrder',
        method: 'get',
        params: data,
        responseType: 'blob'
    })
}
export const exportDeptEmployeeDetailOrder = (data) => {
    return request({
        url: preFix + '/exportDeptOrderDetail',
        method: 'get',
        params: data,
        responseType: 'blob'
    })
}
export const reqAdminCancelOrder = (data) => {
    return request({
        url: preFix + '/adminCancelOrder',
        method: 'get',
        params: data,
    })
}
export const reqVerifyOrderRecord = (data) => {
    return request({
        url: preFix + '/verifyOrderRecord',
        method: 'get',
        params: data,
    })
}
export const reqVerifyOrder = (data) => {
    return request({
        url: preFix + '/verifyOrder',
        method: 'get',
        params: data,
    })
}


